import { Box } from '@chakra-ui/react';

import { TextRegular } from 'UiKit/typography';
import { BG_STATUS_COLORS, TEXT_STATUS_COLORS } from './const';

import styles from './styles.module.css';

const StatusBadge = ({ name }) => {
  const backgroundColor = BG_STATUS_COLORS[name] || '#FFFFFF';
  const textColor = TEXT_STATUS_COLORS[name] || '#FFFFFF';
  return (
    <Box className={styles['status-badge__container']} backgroundColor={backgroundColor} data-testid="status-badge">
      <TextRegular fontSize="10px" color={textColor}>
        {name}
      </TextRegular>
    </Box>
  );
};

export default StatusBadge;
